import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15b91d65"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "restore-profile-screen" }
const _hoisted_2 = { class: "content mb-0" }
const _hoisted_3 = {
  key: 0,
  class: "profile-loader"
}
const _hoisted_4 = { class: "overlay" }
const _hoisted_5 = {
  key: 0,
  class: "address"
}
const _hoisted_6 = { class: "profile-address mb-6" }
const _hoisted_7 = {
  key: 1,
  class: "address profile-address-single has-text-centered mb-6"
}
const _hoisted_8 = { class: "tags" }
const _hoisted_9 = { class: "question" }
const _hoisted_10 = { class: "buttons" }

import { ref, inject, Ref, watch } from 'vue'

import ProfilePicture from '@/popup/components/shared/ProfilePicture/ProfilePicture.vue'
import RestoreWizard from '@/popup/components/shared/Wizard.vue'
import Spinner from '@/popup/components/shared/Spinner.vue'
import Button from '@/popup/components/shared/Button.vue'
import { fetchLatestProfile } from '@/popup/utils/profiles'
import ProfileBackground from '@/popup/components/shared/ProfileBackground/ProfileBackground.vue'
import SvgIcon from '@/popup/components/shared/SvgIcon.vue'
import UserName from '@/popup/components/shared/Miscellaneous/UserName.vue'
import { truncateMiddle } from '@/shared/utils'
import { ProfileDTO } from '@/business-logic/wallet'
import { FrontendProfile } from '@/shared/models/Profile'
import { useNotifications } from '@/popup/compositions/useNotifications'

type Emits = {
  (event: 'on-restore-confirm'): void
  (event: 'on-restore-cancel'): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmSingle',
  emits: ["on-restore-confirm", "on-restore-cancel"],
  setup(__props, { emit: __emit }) {

const { addSomethingWentWrongError } = useNotifications()

const emits = __emit

const profiles = inject<Ref<ProfileDTO[]>>('profiles', ref([]))
const profile = ref<FrontendProfile>()

const onCancel = async () => {
  emits('on-restore-cancel')
}

const onSubmit = async () => {
  emits('on-restore-confirm')
}

watch(
  profiles,
  async newProfiles => {
    try {
      if (newProfiles.length === 0) {
        return
      }
      const { address } = newProfiles[0]
      profile.value = address
        ? await fetchLatestProfile({ address })
        : undefined
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : 'Unknown error.'
      const message = `Error while fetching profile in ConfirmSingle: ${errorMessage}`
      addSomethingWentWrongError(message)
    }
  },
  { immediate: true }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(RestoreWizard, {
      title: _ctx.$t('restore_wizard.confirm_profile'),
      progress: 75
    }, null, 8 /* PROPS */, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      (!profile.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(Spinner, { "box-size": 12 })
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", {
        class: _normalizeClass(["profile-content", {
          loaded: !!profile.value,
        }])
      }, [
        _createVNode(ProfileBackground, {
          "profile-background": profile.value?.coverPicture,
          height: 324,
          width: 360
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(ProfilePicture, {
                "frontend-profile": profile.value,
                size: "large",
                "with-identicon": true
              }, null, 8 /* PROPS */, ["frontend-profile"]),
              _createElementVNode("div", null, [
                (profile.value?.name)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createVNode(UserName, {
                        profile: profile.value,
                        "max-width": 210,
                        "has-at-sign": true,
                        "has-slice-address": true,
                        "name-class": "gradient-text",
                        class: "is-justify-content-center mb-2"
                      }, null, 8 /* PROPS */, ["profile"]),
                      _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(truncateMiddle)(profile.value.address, 8)), 1 /* TEXT */)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(truncateMiddle)(profile.value?.address, 8)), 1 /* TEXT */)),
                _createElementVNode("div", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(profile.value?.tags, (tag) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: tag,
                      class: "tag"
                    }, _toDisplayString(tag), 1 /* TEXT */))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ]),
              _createElementVNode("h3", _hoisted_9, _toDisplayString(_ctx.$t('restore_wizard.confirm_question')), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(Button, {
                  variant: "text",
                  "is-full-width": true,
                  onClick: onCancel,
                  "data-testid": "cancel-button"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('qr_code.import_profile.cancel')), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(Button, {
                  variant: "primary",
                  "is-full-width": true,
                  disabled: !profile.value,
                  onClick: onSubmit,
                  "data-testid": "submit-button"
                }, {
                  default: _withCtx(() => [
                    _createVNode(SvgIcon, {
                      name: "restore-profile",
                      color: "var(--neutral-100)",
                      class: "mr-2"
                    }),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('restore_wizard.restore')), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["disabled"])
              ])
            ])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["profile-background"])
      ], 2 /* CLASS */)
    ])
  ]))
}
}

})